import { useReducer } from 'react';
import { initialExploreQuery } from '../../helpers/dummyQuery';
import { setExploreQuery, resetExplore } from '../../helpers/reducer';

export enum ExploreActionType {
    setExplore,
    reset,
}

export type ExploreAction =
    | { type: ExploreActionType.reset }
    | { type: ExploreActionType.setExplore; query: ExploreQueryT };

const exploreReducer = (
    state: ExploreQueryT,
    action: ExploreAction,
): ExploreQueryT => {
    switch (action.type) {
        case ExploreActionType.setExplore:
            return setExploreQuery(state, action.query);
        case ExploreActionType.reset:
            return resetExplore();
        default:
            return state;
    }
};

export const useExploreReducer = () =>
    useReducer(exploreReducer, initialExploreQuery);
